<template>
  <div class="d-flex flex-column my-3 pa-1 justify-center allBtnsDiv">
    <v-text-field
      v-model="search"
      hide-details
      outlined
      dense
      rounded
      placeholder="Search All Conditions"
      class="my-2 d-none d-sm-flex"
      @keyup.enter="doSearch()"
      ref="input"
    ></v-text-field>

    <v-btn
      v-for="(type, index) in conditionTypes"
      :key="index"
      width="95%"
      depressed
      small
      link
      class="my-1 mx-auto"
      active-class="activeButton"
      :to="{ path: '/ocular-conditions/category/' + type.slug }"
    >
      <v-icon x-small v-if="type.icon" class="mr-1">mdi-{{ type.icon }}</v-icon>
      {{ type.title }}</v-btn
    >
  </div>
</template>

<script>
// import ConditionsCategories from "@/assets/js/conditions/ConditionsCategories";
import WatcherMixin from "@/assets/js/WatcherMixin";
import GetJsonMixin from "@/assets/js/GetJsonMixin";

export default {
  name: "ConditionsMenuBtns",
  components: {},
  mixins: [WatcherMixin, GetJsonMixin],

  props: {},
  data: function () {
    return {
      // menus: null,
      mode: "category",
      isCurrentMode: false,
      selectedTypeIndex: null,
      search: null,
      conditionTypes: null,
    };
  },
  methods: {
    doSearch() {
      if (this.search) {
        this.$router.push({
          path: "/ocular-conditions/search/" + encodeURI(this.search),
        });
        this.$refs.input.reset();
      }
      // ! if changing this, remember there is also a search function in /views/conditions (for small screens)
    },
  },
  computed: {
    // conditionTypes: function () {
    //   return ConditionsCategories.conditionTypes;
    // },
  },

  mounted() {
    this.getJSON("dzCategories", "json", ["conditionTypes"]); // in the mixin
  },
};
</script>

<style scoped>
.allBtnsDiv >>> .activeButton {
  background-color: #d6f3ff;
}
/* .allBtnsDiv >>> .v-btn__content {
  text-align: left;
} */
.allBtnsDiv >>> .v-btn {
  justify-content: left !important;
}
</style>
